import React from 'react';

export default function ChromeExtension() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 rounded-3xl overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
            {/* Left content */}
            <div className="p-10 lg:p-14 flex flex-col justify-center">
              <div className="inline-flex items-center gap-2 bg-white/10 text-white text-xs font-semibold px-3 py-1.5 rounded-full mb-6 w-fit">
                <span className="text-green-400">●</span> Chrome Extension
              </div>
              <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4 leading-tight">
                Add Director Discovery to Chrome
              </h2>
              <p className="text-gray-400 text-base leading-relaxed mb-8">
                Build lists and prospect from any website — LinkedIn, company pages, social networks, or anywhere on the web. Capture verified contact info without leaving your browser.
              </p>
              <div className="space-y-3 mb-8">
                {[
                  'Works on any website',
                  'LinkedIn & social network profiles',
                  'One-click email & phone reveal',
                  'Export directly to CRM',
                ].map((f) => (
                  <div key={f} className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-green-500 flex items-center justify-center flex-shrink-0">
                      <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span className="text-gray-300 text-sm">{f}</span>
                  </div>
                ))}
              </div>
              <a href="#" className="inline-flex items-center gap-2 bg-white text-gray-900 font-semibold px-6 py-3 rounded-xl text-sm hover:bg-gray-100 transition-colors w-fit shadow-sm">
                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z"/>
                </svg>
                Add to Chrome — It's free
              </a>
            </div>

            {/* Right — mock extension preview */}
            <div className="relative p-10 lg:p-14 flex items-center justify-center">
              {/* Any website card */}
              <div className="absolute top-8 left-8 bg-white/10 backdrop-blur-sm rounded-2xl p-4 border border-white/10 w-48">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-6 h-6 rounded bg-blue-500 flex items-center justify-center text-white text-xs font-bold">in</div>
                  <span className="text-white text-xs font-medium">LinkedIn Profile</span>
                </div>
                <div className="space-y-1.5">
                  <div className="h-2 bg-white/20 rounded-full w-full" />
                  <div className="h-2 bg-white/20 rounded-full w-3/4" />
                </div>
                <div className="mt-3 flex gap-1">
                  <span className="text-xs bg-green-500 text-white px-2 py-0.5 rounded-full font-medium">✓ Email found</span>
                </div>
              </div>

              {/* Social network card */}
              <div className="absolute bottom-8 right-8 bg-white/10 backdrop-blur-sm rounded-2xl p-4 border border-white/10 w-48">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-6 h-6 rounded bg-sky-500 flex items-center justify-center text-white text-xs font-bold">𝕏</div>
                  <span className="text-white text-xs font-medium">Social Profile</span>
                </div>
                <div className="space-y-1.5">
                  <div className="h-2 bg-white/20 rounded-full w-full" />
                  <div className="h-2 bg-white/20 rounded-full w-2/3" />
                </div>
                <div className="mt-3 flex gap-1">
                  <span className="text-xs bg-green-500 text-white px-2 py-0.5 rounded-full font-medium">✓ Mobile found</span>
                </div>
              </div>

              {/* Center extension popup */}
              <div className="bg-white rounded-2xl shadow-2xl w-64 overflow-hidden border border-gray-100 z-10 relative">
                <div className="flex items-center gap-2 px-4 py-3 border-b border-gray-100 bg-indigo-600">
                  <div className="w-5 h-5 bg-white rounded flex items-center justify-center">
                    <span className="text-indigo-600 text-xs font-black">P</span>
                  </div>
                  <span className="text-white text-xs font-semibold">Director Discovery Extension</span>
                </div>
                <div className="p-4">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-700 font-bold text-sm">JD</div>
                    <div>
                      <p className="text-sm font-semibold text-gray-900">Jane Doe</p>
                      <p className="text-xs text-gray-400">VP Sales at Acme</p>
                    </div>
                  </div>
                  <div className="space-y-2 mb-4">
                    <div className="flex items-center gap-2 bg-green-50 px-3 py-2 rounded-lg">
                      <span className="text-green-500 text-xs">✉</span>
                      <span className="text-xs text-gray-700 font-medium font-mono">j.doe@acme.com</span>
                      <span className="ml-auto text-xs bg-green-100 text-green-600 px-1.5 py-0.5 rounded font-semibold">✓</span>
                    </div>
                    <div className="flex items-center gap-2 bg-blue-50 px-3 py-2 rounded-lg">
                      <span className="text-blue-500 text-xs">📱</span>
                      <span className="text-xs text-gray-700 font-medium font-mono">+1 (415) ···-8931</span>
                      <span className="ml-auto text-xs bg-blue-100 text-blue-600 px-1.5 py-0.5 rounded font-semibold">✓</span>
                    </div>
                  </div>
                  <button className="w-full bg-indigo-600 text-white text-xs font-semibold py-2 rounded-lg hover:bg-indigo-700 transition-colors">
                    Export to CRM
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
